import universal from 'react-universal-component';

export const SearchMap = universal(import(/* webpackChunkName: "SearchMap" */'./SearchMap'));
export CardMap from './CardMap';
